import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=a38618dc&scoped=true"
import script from "./UpdateModal.vue?vue&type=script&lang=js"
export * from "./UpdateModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateModal.vue?vue&type=style&index=0&id=a38618dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38618dc",
  null
  
)

export default component.exports